import type { Severity } from "../lib/format";

interface Props {
  values: number[];
  width?: number;
  height?: number;
  severity?: Severity;
}

const STROKE: Record<Severity, string> = {
  ok: "#3bd278",
  warn: "#f0c044",
  crit: "#ff6173",
  unknown: "#5f6877",
};

export function Sparkline({
  values,
  width = 72,
  height = 22,
  severity = "unknown",
}: Props) {
  if (values.length < 2) {
    return (
      <span
        className="sparkline sparkline-empty"
        style={{ width, height }}
        aria-hidden="true"
      />
    );
  }

  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const stepX = width / (values.length - 1);
  const points = values
    .map((v, i) => {
      const x = i * stepX;
      const y = height - 1 - ((v - min) / span) * (height - 2);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");

  return (
    <svg
      className="sparkline"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <polyline
        points={points}
        fill="none"
        stroke={STROKE[severity]}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
